module.exports = __webpack_public_path__ + "img/04-1-1小图.83293b9d.png";